var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"swissprepared-logo",attrs:{"src":require("@/assets/swissprepared-logo.png"),"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }